import { useTranslation } from "react-i18next";

const steps = [
  { key: "step1", icon: "ri-grid-line" },
  { key: "step2", icon: "ri-search-line" },
  { key: "step3", icon: "ri-file-info-line" },
  { key: "step4", icon: "ri-shield-check-line" },
  { key: "step5", icon: "ri-shopping-cart-2-line" },
  { key: "step6", icon: "ri-box-3-line" },
];

export default function StepsSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full px-6 md:px-10 py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground-900">
            {t("steps.title")}
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            {t("steps.subtitle")}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {steps.map((step, idx) => (
            <div
              key={step.key}
              className="relative bg-background-100 rounded-2xl p-6 group hover:bg-background-200/70 transition-colors duration-300"
            >
              <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center mb-4">
                <span className="text-xs font-bold text-accent-700">{idx + 1}</span>
              </div>
              <h3 className="text-base font-bold text-foreground-900">{t(`steps.${step.key}.title`)}</h3>
              <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">{t(`steps.${step.key}.desc`)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}